import React, { useState } from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";
import Testimonials from "../components/Testimonials";

const clarityCallEndpoint = (() => {
  const publicUrl = "https://dailyfitzone.com/api/clarity-call.php";
  return publicUrl;
})();

function ClarityCall() {
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setStatusMessage("");
    setStatusType("");

    const formData = new FormData(event.target);

    try {
      const response = await fetch(clarityCallEndpoint, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Unable to send your request.");
      }

      setStatusMessage(data.message || "Your clarity call request was sent successfully.");
      setStatusType("success");
      event.target.reset();
    } catch (error) {
      setStatusMessage(error.message || "Something went wrong. Please try again later.");
      setStatusType("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Template>
      <BreadCrumb pageName="Clarity Call" />
      <div className="section-lgx pb-0"></div>
      <section className="section-lgx">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <form
                className="contact-form"
                method="post"
                id="contact-form"
                action={clarityCallEndpoint}
                onSubmit={handleSubmit}
              >
                <h4>Book a Clarity Call</h4>
                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        name="name"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-12">
                    <p>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        name="email"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-12">
                    <p>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Phone"
                        name="number"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-lg-12">
                    <button
                      type="submit"
                      className="pbmit-btn pbmit-btn-white pbmit-submit-btn"
                      disabled={isSubmitting}
                    >
                      <i
                        className={`form-btn-loader fa fa-circle-o-notch fa-spin fa-fw margin-bottom ${
                          isSubmitting ? "" : "d-none"
                        }`}
                      />
                      <span className="button-text">
                        {isSubmitting ? "Sending..." : "Send a message"}
                      </span>
                    </button>
                  </div>

                  <div className={`col-md-12 col-lg-12 message-status ${statusType}`}>
                    {statusMessage}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Testimonials />
    </Template>
  );
}

export default ClarityCall;
